var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dialog-demo"}},[_c('dialogs-alert'),_c('dialogs-confirm'),_c('dialogs-prompt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }